@if (solrDataOption) {
  @switch (solrDataOption.dataType) {
    @case (solrDate) {
      <div class="mb-2 d-inline-block">
        <rl-text-mode-date-input [(ngModel)]="value"
        (ngModelChange)="emitDateChange()"></rl-text-mode-date-input>
      </div>
    }
    @case (solrDateTime) {
      <div class="mb-2 d-inline-block">
        <rl-text-mode-date-input [(ngModel)]="value"
        (ngModelChange)="emitDateTimeChange()"></rl-text-mode-date-input>
      </div>
    }
    @default {
      @if (hasTypeahead) {
        <span class="inputTypeAhead">
          <select aria-label="Type Ahead Dropdown" class="form-select inputTypeAhead-select"
            autocomplete="off">
            <!-- leave blank - used for styling purposes only -->
          </select>
          <input aria-label="Type Ahead Input" class="form-control inputTypeAhead-input" type="text"
            name="single-value-input" [(ngModel)]="typeaheadValue"
            (keydown.backspace)="backspacePressed($event)" [placeholder]="solrDataOption.placeholder"
            [ngbTypeahead]="searchValues" (focus)="focus$.next($event.target.value)"
            (click)="click$.next($event.target.value)" (selectItem)="valueSelected($event)"
            (keyup.enter)="typeAheadEntered()" [inputFormatter]="formatter" [resultFormatter]="formatter"
            autocomplete="off" #typeahead data-cy="ValueInputWithTypeAheadTextBox" />
        </span>
      }
      @if (!hasTypeahead) {
        <input aria-label="Value Input Text Box" class="form-control" type="text" [(ngModel)]="value"
          (ngModelChange)="emitChange()" (keydown.enter)="enterKeyPress()"
          [placeholder]="solrDataOption.placeholder" data-cy="ValueInputTextBox" />
      }
    }
  }
}